const checkboxContainerClass = '.js-tick-all-checkbox-container';
const agreeToAllOptinCheckboxClass = '.js-tick-all-checkbox';
const optinChannelCheckboxes = '.js-optin-channel-checkbox';
const agreeToAllSelector = '[data-id=AgreeToAllOptin]';

function UpdateCheckboxState(checkboxElement, isChecked) {
  const $checkbox = $(checkboxElement);
  if ($checkbox.length > 0) {
    if (isChecked) {
      $checkbox.parent().addClass('active');
      $checkbox.prop('checked', true);
    } else {
      $checkbox.parent().removeClass('active');
      $checkbox.prop('checked', false);
    }
  }
}

function agreeToAllOptin() {
  $(agreeToAllOptinCheckboxClass).click((event) => {
    const currentTarget = event.currentTarget;
    const $agreeToAllCheckbox = $(agreeToAllSelector);

    const $userConsentsCheckboxes = $(currentTarget)
      .closest(checkboxContainerClass)
      .find('input:checkbox')
      .not(this)
      .not(optinChannelCheckboxes);

    if ($agreeToAllCheckbox.length > 0 && $agreeToAllCheckbox.is(':checkbox')) {
      UpdateCheckboxState($userConsentsCheckboxes, currentTarget.checked);
    } else {
      $userConsentsCheckboxes.prop('checked', currentTarget.checked);
    }
  });

  $(document).ready(() => {
    if (typeof OCMS.ShouldAutoCheckConsents !== 'undefined' && OCMS.ShouldAutoCheckConsents === true) {
      $(agreeToAllOptinCheckboxClass).click();
    }
    $(checkboxContainerClass)
      .find('input:checkbox')
      .not(agreeToAllOptinCheckboxClass)
      .not(optinChannelCheckboxes)
      .click((event) => {
        const $currentTarget = $(event.currentTarget);
        const $agreeToAllCheckbox = $(agreeToAllSelector);
        let isAnyCheckboxUnchecked = true;
        isAnyCheckboxUnchecked = $currentTarget
          .closest(checkboxContainerClass)
          .find('input:checkbox:not(":checked")')
          .not(agreeToAllOptinCheckboxClass)
          .not(optinChannelCheckboxes)
          .length > 0;
        $currentTarget
          .closest(checkboxContainerClass)
          .find(agreeToAllOptinCheckboxClass)
          .prop('checked', !isAnyCheckboxUnchecked);
        if ($agreeToAllCheckbox.length > 0) {
          UpdateCheckboxState($agreeToAllCheckbox, !isAnyCheckboxUnchecked);
        }
      });
  });
}

function IsAllOptinValid() {
  const $allOptinContainer = $(checkboxContainerClass);
  if ($allOptinContainer.length > 0) {
    return $allOptinContainer
      .find('input:checkbox')
      .not(optinChannelCheckboxes)
      .not(':checked').length === 0;
  }
  return true;
}

export default agreeToAllOptin;
export {
  IsAllOptinValid
};



// WEBPACK FOOTER //
// ./js/common/molecule/agree-to-all-optin.js